import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-cy"]
const _hoisted_2 = {
  key: 0,
  class: "ion-no-margin"
}
const _hoisted_3 = {
  key: 1,
  class: "ion-no-margin"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_storeStatus = _resolveComponent("storeStatus")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_addressDisplay = _resolveComponent("addressDisplay")!
  const _component_storeTime = _resolveComponent("storeTime")!
  const _component_ion_item_divider = _resolveComponent("ion-item-divider")!
  const _component_ion_skeleton_text = _resolveComponent("ion-skeleton-text")!
  const _component_ion_badge = _resolveComponent("ion-badge")!

  return (_ctx.storeLocation)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.select())),
        class: _normalizeClass(["ion-no-padding location-info", { clickable: _ctx.clickable, 'pa-0': _ctx.detail }]),
        "data-cy": 'location-' + _ctx.storeLocation.slug
      }, [
        (_ctx.storeLocation.hours)
          ? (_openBlock(), _createBlock(_component_storeStatus, {
              key: 0,
              storeLocation: _ctx.storeLocation,
              class: "pl-16"
            }, null, 8, ["storeLocation"]))
          : _createCommentVNode("", true),
        _createVNode(_component_ion_row, { class: "ion-justify-contents-between" }, {
          default: _withCtx(() => [
            (_ctx.storeLocation?.name)
              ? (_openBlock(), _createBlock(_component_ion_col, {
                  key: 0,
                  "data-cy": "location-name",
                  class: "pl-16"
                }, {
                  default: _withCtx(() => [
                    (_ctx.detail)
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(_ctx.storeLocation.name), 1))
                      : (_openBlock(), _createElementBlock("h5", _hoisted_3, _toDisplayString(_ctx.storeLocation.name) + _toDisplayString(_ctx.isRedRobinStore ? ' | Red Robin' : ''), 1))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.storeLocation?.distance && _ctx.detail)
              ? (_openBlock(), _createBlock(_component_ion_col, {
                  key: 1,
                  size: "2",
                  class: "pl-0"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.storeLocation.distance ? _ctx.storeLocation.distance + 'mi' : ''), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_ion_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_col, { class: "px-16" }, {
              default: _withCtx(() => [
                _createVNode(_component_addressDisplay, {
                  address: _ctx.storeLocation.address,
                  inline: !_ctx.detail,
                  "data-cy": "location-address"
                }, null, 8, ["address", "inline"]),
                (_ctx.detail && _ctx.phoneLink)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: _ctx.phoneLink.href,
                      class: "small bold",
                      "data-cy": "location-phone"
                    }, _toDisplayString(_ctx.phoneLink.text), 9, _hoisted_4))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (!_ctx.detail)
          ? (_openBlock(), _createBlock(_component_ion_row, {
              key: 1,
              class: "ion-text-start ion-align-items-center simple-row ion-justify-content-between color-dark"
            }, {
              default: _withCtx(() => [
                (_ctx.storeLocation?.distance || _ctx.storeLocation?.distance === 0)
                  ? (_openBlock(), _createBlock(_component_ion_col, {
                      key: 0,
                      class: "small pl-16"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.storeLocation.distance ? _ctx.storeLocation.distance + 'mi' : '0.00'), 1),
                        (_ctx.storeLocation.hours && _ctx.storeLocation.hours.length > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_5, " | "))
                          : _createCommentVNode("", true),
                        (_ctx.storeLocation && _ctx.storeLocation.hours && _ctx.storeLocation.hours.length > 0)
                          ? (_openBlock(), _createBlock(_component_storeTime, {
                              key: 1,
                              storeLocation: _ctx.storeLocation,
                              showTodayHours: "",
                              boldTime: "",
                              class: "d-inline color-dark"
                            }, null, 8, ["storeLocation"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_ion_row, {
              key: 2,
              class: "ion-margin-vertical"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_item_divider),
                (_ctx.storeLocation)
                  ? (_openBlock(), _createBlock(_component_storeTime, {
                      key: 0,
                      storeLocation: _ctx.storeLocation,
                      boldTime: ""
                    }, null, 8, ["storeLocation"]))
                  : (_openBlock(), _createBlock(_component_ion_skeleton_text, {
                      key: 1,
                      style: {"width":"50%","margin":"20px 0"}
                    })),
                _createVNode(_component_ion_item_divider)
              ]),
              _: 1
            })),
        (!_ctx.detail && _ctx.storeLocation.orderType?.includes('Window'))
          ? (_openBlock(), _createBlock(_component_ion_row, { key: 3 }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_badge, {
                  class: "mx-16 mt-8 color-light",
                  color: "dark",
                  mode: "ios"
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode("Pick-Up Window")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ], 10, _hoisted_1))
    : _createCommentVNode("", true)
}